/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RetailerIndexRouteImport } from './routes/$retailer/index'
import { Route as RetailerReviewRouteImport } from './routes/$retailer/review'
import { Route as RetailerReasonsRouteImport } from './routes/$retailer/reasons'
import { Route as RetailerOrderlessRouteImport } from './routes/$retailer/orderless'
import { Route as RetailerMethodRouteImport } from './routes/$retailer/method'
import { Route as RetailerItemSelectionRouteImport } from './routes/$retailer/item-selection'
import { Route as RetailerGiftLoginRouteImport } from './routes/$retailer/gift-login'
import { Route as RetailerExchangeRouteImport } from './routes/$retailer/exchange'
import { Route as RetailerCompleteRouteImport } from './routes/$retailer/complete'
import { Route as RetailerClaimDetailsRouteImport } from './routes/$retailer/claim-details'
import { Route as RetailerSubmittedDetailsRequestIdRouteImport } from './routes/$retailer/submitted-details/$requestId'
import { Route as RetailerIneligibleDetailsItemIdRouteImport } from './routes/$retailer/ineligible-details/$itemId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerIndexRoute = RetailerIndexRouteImport.update({
  id: '/$retailer/',
  path: '/$retailer/',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerReviewRoute = RetailerReviewRouteImport.update({
  id: '/$retailer/review',
  path: '/$retailer/review',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerReasonsRoute = RetailerReasonsRouteImport.update({
  id: '/$retailer/reasons',
  path: '/$retailer/reasons',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerOrderlessRoute = RetailerOrderlessRouteImport.update({
  id: '/$retailer/orderless',
  path: '/$retailer/orderless',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerMethodRoute = RetailerMethodRouteImport.update({
  id: '/$retailer/method',
  path: '/$retailer/method',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerItemSelectionRoute = RetailerItemSelectionRouteImport.update({
  id: '/$retailer/item-selection',
  path: '/$retailer/item-selection',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerGiftLoginRoute = RetailerGiftLoginRouteImport.update({
  id: '/$retailer/gift-login',
  path: '/$retailer/gift-login',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerExchangeRoute = RetailerExchangeRouteImport.update({
  id: '/$retailer/exchange',
  path: '/$retailer/exchange',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerCompleteRoute = RetailerCompleteRouteImport.update({
  id: '/$retailer/complete',
  path: '/$retailer/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerClaimDetailsRoute = RetailerClaimDetailsRouteImport.update({
  id: '/$retailer/claim-details',
  path: '/$retailer/claim-details',
  getParentRoute: () => rootRouteImport,
} as any)
const RetailerSubmittedDetailsRequestIdRoute =
  RetailerSubmittedDetailsRequestIdRouteImport.update({
    id: '/$retailer/submitted-details/$requestId',
    path: '/$retailer/submitted-details/$requestId',
    getParentRoute: () => rootRouteImport,
  } as any)
const RetailerIneligibleDetailsItemIdRoute =
  RetailerIneligibleDetailsItemIdRouteImport.update({
    id: '/$retailer/ineligible-details/$itemId',
    path: '/$retailer/ineligible-details/$itemId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$retailer/claim-details': typeof RetailerClaimDetailsRoute
  '/$retailer/complete': typeof RetailerCompleteRoute
  '/$retailer/exchange': typeof RetailerExchangeRoute
  '/$retailer/gift-login': typeof RetailerGiftLoginRoute
  '/$retailer/item-selection': typeof RetailerItemSelectionRoute
  '/$retailer/method': typeof RetailerMethodRoute
  '/$retailer/orderless': typeof RetailerOrderlessRoute
  '/$retailer/reasons': typeof RetailerReasonsRoute
  '/$retailer/review': typeof RetailerReviewRoute
  '/$retailer': typeof RetailerIndexRoute
  '/$retailer/ineligible-details/$itemId': typeof RetailerIneligibleDetailsItemIdRoute
  '/$retailer/submitted-details/$requestId': typeof RetailerSubmittedDetailsRequestIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$retailer/claim-details': typeof RetailerClaimDetailsRoute
  '/$retailer/complete': typeof RetailerCompleteRoute
  '/$retailer/exchange': typeof RetailerExchangeRoute
  '/$retailer/gift-login': typeof RetailerGiftLoginRoute
  '/$retailer/item-selection': typeof RetailerItemSelectionRoute
  '/$retailer/method': typeof RetailerMethodRoute
  '/$retailer/orderless': typeof RetailerOrderlessRoute
  '/$retailer/reasons': typeof RetailerReasonsRoute
  '/$retailer/review': typeof RetailerReviewRoute
  '/$retailer': typeof RetailerIndexRoute
  '/$retailer/ineligible-details/$itemId': typeof RetailerIneligibleDetailsItemIdRoute
  '/$retailer/submitted-details/$requestId': typeof RetailerSubmittedDetailsRequestIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$retailer/claim-details': typeof RetailerClaimDetailsRoute
  '/$retailer/complete': typeof RetailerCompleteRoute
  '/$retailer/exchange': typeof RetailerExchangeRoute
  '/$retailer/gift-login': typeof RetailerGiftLoginRoute
  '/$retailer/item-selection': typeof RetailerItemSelectionRoute
  '/$retailer/method': typeof RetailerMethodRoute
  '/$retailer/orderless': typeof RetailerOrderlessRoute
  '/$retailer/reasons': typeof RetailerReasonsRoute
  '/$retailer/review': typeof RetailerReviewRoute
  '/$retailer/': typeof RetailerIndexRoute
  '/$retailer/ineligible-details/$itemId': typeof RetailerIneligibleDetailsItemIdRoute
  '/$retailer/submitted-details/$requestId': typeof RetailerSubmittedDetailsRequestIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$retailer/claim-details'
    | '/$retailer/complete'
    | '/$retailer/exchange'
    | '/$retailer/gift-login'
    | '/$retailer/item-selection'
    | '/$retailer/method'
    | '/$retailer/orderless'
    | '/$retailer/reasons'
    | '/$retailer/review'
    | '/$retailer'
    | '/$retailer/ineligible-details/$itemId'
    | '/$retailer/submitted-details/$requestId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$retailer/claim-details'
    | '/$retailer/complete'
    | '/$retailer/exchange'
    | '/$retailer/gift-login'
    | '/$retailer/item-selection'
    | '/$retailer/method'
    | '/$retailer/orderless'
    | '/$retailer/reasons'
    | '/$retailer/review'
    | '/$retailer'
    | '/$retailer/ineligible-details/$itemId'
    | '/$retailer/submitted-details/$requestId'
  id:
    | '__root__'
    | '/'
    | '/$retailer/claim-details'
    | '/$retailer/complete'
    | '/$retailer/exchange'
    | '/$retailer/gift-login'
    | '/$retailer/item-selection'
    | '/$retailer/method'
    | '/$retailer/orderless'
    | '/$retailer/reasons'
    | '/$retailer/review'
    | '/$retailer/'
    | '/$retailer/ineligible-details/$itemId'
    | '/$retailer/submitted-details/$requestId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RetailerClaimDetailsRoute: typeof RetailerClaimDetailsRoute
  RetailerCompleteRoute: typeof RetailerCompleteRoute
  RetailerExchangeRoute: typeof RetailerExchangeRoute
  RetailerGiftLoginRoute: typeof RetailerGiftLoginRoute
  RetailerItemSelectionRoute: typeof RetailerItemSelectionRoute
  RetailerMethodRoute: typeof RetailerMethodRoute
  RetailerOrderlessRoute: typeof RetailerOrderlessRoute
  RetailerReasonsRoute: typeof RetailerReasonsRoute
  RetailerReviewRoute: typeof RetailerReviewRoute
  RetailerIndexRoute: typeof RetailerIndexRoute
  RetailerIneligibleDetailsItemIdRoute: typeof RetailerIneligibleDetailsItemIdRoute
  RetailerSubmittedDetailsRequestIdRoute: typeof RetailerSubmittedDetailsRequestIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/': {
      id: '/$retailer/'
      path: '/$retailer'
      fullPath: '/$retailer'
      preLoaderRoute: typeof RetailerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/review': {
      id: '/$retailer/review'
      path: '/$retailer/review'
      fullPath: '/$retailer/review'
      preLoaderRoute: typeof RetailerReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/reasons': {
      id: '/$retailer/reasons'
      path: '/$retailer/reasons'
      fullPath: '/$retailer/reasons'
      preLoaderRoute: typeof RetailerReasonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/orderless': {
      id: '/$retailer/orderless'
      path: '/$retailer/orderless'
      fullPath: '/$retailer/orderless'
      preLoaderRoute: typeof RetailerOrderlessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/method': {
      id: '/$retailer/method'
      path: '/$retailer/method'
      fullPath: '/$retailer/method'
      preLoaderRoute: typeof RetailerMethodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/item-selection': {
      id: '/$retailer/item-selection'
      path: '/$retailer/item-selection'
      fullPath: '/$retailer/item-selection'
      preLoaderRoute: typeof RetailerItemSelectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/gift-login': {
      id: '/$retailer/gift-login'
      path: '/$retailer/gift-login'
      fullPath: '/$retailer/gift-login'
      preLoaderRoute: typeof RetailerGiftLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/exchange': {
      id: '/$retailer/exchange'
      path: '/$retailer/exchange'
      fullPath: '/$retailer/exchange'
      preLoaderRoute: typeof RetailerExchangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/complete': {
      id: '/$retailer/complete'
      path: '/$retailer/complete'
      fullPath: '/$retailer/complete'
      preLoaderRoute: typeof RetailerCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/claim-details': {
      id: '/$retailer/claim-details'
      path: '/$retailer/claim-details'
      fullPath: '/$retailer/claim-details'
      preLoaderRoute: typeof RetailerClaimDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/submitted-details/$requestId': {
      id: '/$retailer/submitted-details/$requestId'
      path: '/$retailer/submitted-details/$requestId'
      fullPath: '/$retailer/submitted-details/$requestId'
      preLoaderRoute: typeof RetailerSubmittedDetailsRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$retailer/ineligible-details/$itemId': {
      id: '/$retailer/ineligible-details/$itemId'
      path: '/$retailer/ineligible-details/$itemId'
      fullPath: '/$retailer/ineligible-details/$itemId'
      preLoaderRoute: typeof RetailerIneligibleDetailsItemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RetailerClaimDetailsRoute: RetailerClaimDetailsRoute,
  RetailerCompleteRoute: RetailerCompleteRoute,
  RetailerExchangeRoute: RetailerExchangeRoute,
  RetailerGiftLoginRoute: RetailerGiftLoginRoute,
  RetailerItemSelectionRoute: RetailerItemSelectionRoute,
  RetailerMethodRoute: RetailerMethodRoute,
  RetailerOrderlessRoute: RetailerOrderlessRoute,
  RetailerReasonsRoute: RetailerReasonsRoute,
  RetailerReviewRoute: RetailerReviewRoute,
  RetailerIndexRoute: RetailerIndexRoute,
  RetailerIneligibleDetailsItemIdRoute: RetailerIneligibleDetailsItemIdRoute,
  RetailerSubmittedDetailsRequestIdRoute:
    RetailerSubmittedDetailsRequestIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
